import React, { useState, useEffect } from "react";
import { Container} from "react-bootstrap";
import "./Dashboard.css";
import ManagerService from "../../services/ManagerService";
import BangBdSc from "./BangBdSc";
import ReturnButton from "./ReturnButton";

const ThongKeBdSc = ({ setComponentDuocChon }) => {
  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await ManagerService.Lay_DS_Bd_Sc();
        console.log(response);
        setDashboardData(response);
      } catch (error) {
        console.error("Error fetching profit data:", error);
      }
    };
    
    fetchDashboardData();
  }, []);
    
  return (
    <Container fluid>
      <ReturnButton setComponentDuocChon={setComponentDuocChon} />
      <BangBdSc data={dashboardData?.data || []} />
    </Container>
  );
};

export default ThongKeBdSc;